(ns io.daskul.tutorial.webapp.domain.feature-flags.subs
  "Feature flags subscriptions."
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::all
 (fn [db _]
   (get-in db [:feature-flags :flags] {})))

(rf/reg-sub
 ::loading?
 (fn [db _]
   (get-in db [:feature-flags :loading?] false)))

(rf/reg-sub
 ::error
 (fn [db _]
   (get-in db [:feature-flags :error])))

(rf/reg-sub
 ::enabled?
 :<- [::all]
 (fn [flags [_ flag-name]]
   (get-in flags [flag-name :enabled] false)))

(rf/reg-sub
 ::flag
 :<- [::all]
 (fn [flags [_ flag-name]]
   (get flags flag-name)))
